import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getUser, getToken } from "../../Utils/Common";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import ReactStars from "react-rating-stars-component";
import "./takebreak.css";

function ThanksPage(params) {
  const [loader, setLoader] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const [recommendBook, setRecommendBook] = useState([]);
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const [avgStar, setAvgStar] = useState();

  const book_code = localStorage.getItem("book code");
  const success_message = localStorage.getItem("thanks message");

  const user = getUser();
  const token = getToken();
  const navigate = useNavigate();

  console.log(book_code);

  useEffect(() => {
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + `v1/guest/book-detail/${book_code}`,
      method: "get",
      headers: {
        Accept: "application/json",
      },
    };

    axios(axiosOptions)
      .then((response) => {
        console.log(response.data.data);
        setAvgStar(parseInt(response.data.data.average_rating));
        setData(response.data.data);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        }
      })
      .then(function () {
        // always executed
        setLoader(false);
      });
  }, []);

  useEffect(() => {
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + "v1/user/recommended-book",
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(axiosOptions)
      .then((response) => {
        setRecommendBook(response.data.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        }
      });
  }, []);

  const handleDragStart = (e) => e.preventDefault();
  const images = recommendBook.map((img) => {
    return (
      <div className="item" key={img.id}>
        <Link to={`/book-detail/${img.book_code}`}>
          <img
            src={img.image_path}
            onDragStart={handleDragStart}
            role="presentation"
            height="300"
            width="222"
          />
        </Link>
      </div>
    );
  });

  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  const Carousel = () => (
    <AliceCarousel
      mouseTracking
      items={images}
      responsive={responsive}
      controlsStrategy="alternate"
    />
  );

  console.log(typeof avgStar);
  return (
    <>
      <div className="d-flex justify-content-center">
        <div className={loader === true ? "spinner-border" : ""} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
      {Object.entries(data).length > 0 ? (
        <div
          // className="d-flex flex-column flex-root"
          className="container-fluid "
          style={{ marginTop: "190px" }}
        >
          <div className="container bg-dark">
            {/* <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"> */}
            {/* <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20"> */}
            {/* <div className=" w-lg-500px p-lg-15 bg-dark p-10"> */}
            {/* <div className="w-lg-1000px bg-dark p-10 p-lg-15 mx-auto"> */}
            {/* <div className="d-flex justify-content-center"> */}
            {/* <p className="fs-2hx text-center text-white"> <strong> Thank you ! Your title is now available : </strong></p> */}
            <div className="col-12 col-sm-4 col-md-8 col-lg-12 col-xl-12 offset-xl-1 text-center fs-2hx text-white">
              <p className="fs-2hx">
                {" "}
                <strong> {success_message} </strong>
              </p>
            </div>
            <div className="row">
              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 offset-xl-1 text-end text-white">
                <img alt="Pic" src={data.image_path} />
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 offset-xl-1 text-white text-start">
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                    {" "}
                    <b>Title:</b> {data.title}
                  </div>
                  {/* <div className="col-8">{data.title}</div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    {" "}
                    {/* <b> Des: </b>{" "}{data.description} */}
                  </div>
                  {/* <div className="col-8">{data.description}</div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    {" "}
                    <b>Author:</b> {data.author}
                  </div>
                  {/* <div className="col-8">{data.author}</div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    {" "}
                    <b>Narrated By:</b> {data.narrated_by}
                  </div>
                  {/* <div className="col-8">{data.narrated_by}</div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    {" "}
                    <b>Difficulty: </b>
                    {data.difficulty}
                  </div>
                  {/* <div className="col-8">{data.difficulty}</div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    {" "}
                    <b>Duration: </b> {data.hours} and {data.minutes}
                  </div>
                  {/* <div className="col-8">
                      {data.hours} 12 and 32 {data.minutes}
                    </div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    {" "}
                    <b>Date Publicaton: </b> {data.createdAt}
                  </div>
                  {/* <div className="col-8">
                      {data.hours} 12 and 32 {data.minutes}
                    </div> */}
                </div>
                <div className="row">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ReactStars
                      count={5}
                      size={24}
                      edit={false}
                      isHalf={true}
                      value={data.average_rating}
                      color={"grey"}
                      activeColor={"#ff6600"}
                    />
                  </div>
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-3">
                    {data.notations} notations
                  </div>
                  {/* <div className="col-8">
                      {data.hours} 12 and 32 {data.minutes}
                    </div> */}
                </div>
              </div>
            </div>
            {/* </div> */}
            {/* </div> */}
            {/* </div> */}
            {/* <div className="container-xxl m-19" id="kt_content_container">


          <div className="d-flex justify-content-center m-19"> <p className="fs-1 m-19">thank you page </p></div>
                  </div> */}
            <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
              <div className="bg-body p-10 p-lg-2">
                <p className="mb-10 fs-1">Other good recommendations....</p>
                <Carousel />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
        <div className="bg-body p-10 p-lg-2">
          <p className="mb-10 fs-1">Other good recommendations....</p>
          <Carousel />
        </div>
      </div> */}
    </>
  );
}

export default ThanksPage;
